if (!Math.hypot) {
  Math.hypot = function() {
    var y = 0, i = arguments.length;
    while (i--) y += arguments[i] * arguments[i];
    return Math.sqrt(y);
  }
}


export default (function (window, document) {
  if (!window) {
    return function () {};
  }

  // var passiveEventsSupported = false;

  // try {
  //   window.addEventListener("test", null, Object.defineProperty({}, "passive", { get: function() { passiveEventsSupported = { passive: true }; } }));
  // }

  // catch(err) {}


  var wheelEventName = 'onwheel' in document.body ? 'wheel' : (
    document.onmousewheel ? 'mousewheel' : 'DOMMouseScroll'
  );

  function _addWheelListener(elem, wheelEventName, callback, useCapture) {
    // Modified from
    // https://developer.mozilla.org/en-US/docs/Web/Events/wheel
  
    var listener;

    if (wheelEventName === 'wheel') {
      listener = callback;
    }

    else {
      listener = function( originalEvent ) {
        // normalized event object
        var event = {
          originalEvent: originalEvent,
          target: originalEvent.target || originalEvent.srcElement,
          type: 'wheel',
          deltaMode: originalEvent.type === 'MozMousePixelScroll' ? 0 : 1,
          deltaX: 0,
          deltaY: 0,
          deltaZ: 0,
          preventDefault: function() {
            if (originalEvent.preventDefault) {
              originalEvent.preventDefault();
            }

            else {
              originalEvent.returnValue = false;
            }
          }
        };
        
        if (wheelEventName === 'mousewheel') {
          event.deltaY = - 1 / 40 * originalEvent.wheelDelta;

          if (originalEvent.wheelDeltaX) {
           event.deltaX = - 1 / 40 * originalEvent.wheelDeltaX;
          }
        }

        else {
          event.deltaY = originalEvent.deltaY || originalEvent.detail;
        }

        return callback(event);
      };
    }

    elem.addEventListener(wheelEventName, listener, useCapture || false);
  }

  function addWheelListener (elem, callback, useCapture) {
    // older Firefox
    if (wheelEventName === 'DOMMouseScroll') {
      _addWheelListener(elem, 'MozMousePixelScroll', callback, useCapture);
    }

    else {
      _addWheelListener(elem, wheelEventName, callback, useCapture);
    }
  }

  function getElement (selectorOrElement) {
    if (typeof selectorOrElement === 'string') {
      return document.querySelector(selectorOrElement);
    }

    if (
      selectorOrElement instanceof HTMLElement ||
      selectorOrElement instanceof SVGElement
    ) {
      return selectorOrElement;
    }

    return null;
  }

  function dimensions (elem) {
    var x = 0;
    var y = 0;
    var width = 0;
    var height = 0;

    if (elem instanceof HTMLElement) {
      x = elem.offsetLeft;
      y = elem.offsetTop;
      width = elem.offsetWidth;
      height = elem.offsetHeight;

      // console.log('parent', { width, height, elem});
    }

    else if (elem instanceof SVGElement) {
      var bbox;

      try {
        if (elem.nodeName === 'tspan') {
          bbox = elem.getBoundingClientRect(); // getComputedTextLength
        }

        // else if (elem.nodeName === 'svg' && elem.width && elem.height) {
        //   var widthVal = elem.width.baseVal;
        //   var heightVal = elem.height.baseVal;
        //   var parentDimensions, width, height;

        //   if (widthVal.valueAsString.endsWith('%')) {
        //     parentDimensions = dimensions(elem.parentNode);
        //     width = parentDimensions.width * parseInt(widthVal.valueAsString) / 100;
        //   }

        //   else {
        //     width = widthVal.value;
        //   }

        //   if (heightVal.valueAsString.endsWith('%')) {
        //     if (!parentDimensions) {
        //       parentDimensions = dimensions(elem.parentNode);
        //     }

        //     height = parentDimensions.height * parseInt(heightVal.valueAsString) / 100;
        //   }

        //   else {
        //     height = heightVal.value;
        //   }

        //   console.log({width, height, widthVal, heightVal, parentDimensions});

        //   return {
        //     width,
        //     height
        //   };
        // }

        else {
          bbox = elem.getBBox();
        }

        x = bbox.x || bbox.left;
        y = bbox.y || bbox.top;
        width = bbox.width;
        height = bbox.height;
      }

      catch (err) {}
    }

    return {
      x: x,
      y: y,
      width: width,
      height: height
    };
  }

  // function innerSize (elem, _maxSize) {
  //   var size = dimensions(elem);

  //   if (_maxSize && _maxSize.width * _maxSize.height > size.width * size.height) {
  //     size = _maxSize;
  //   }

  //   var children = Array.prototype.slice.apply(elem.childNodes)
  //     .filter(function (child) {
  //       return child.nodeType === 1;
  //     });
    
  //   children.forEach(function (child) {
  //     var childSize = innerSize(child, size);

  //     if (childSize.width * childSize.height > size.width * size.height) {
  //       size = childSize;
  //     }
  //   });

  //   return size;
  // }

  function setTransform (elem, transformProperty, value, priority) {
    // console.log('setTransform', { elem, transformProperty, value, priority });

    var transformFunction = transformProperty + '(' + value + ')';
    var currentTransform = elem.style.transform;
    var newTransform;

    if (!currentTransform) {
      newTransform = transformFunction;
    }

    else {
      var propertyIndex = currentTransform.indexOf(transformProperty);

      if (propertyIndex === -1) {
        // prioritise translate
        if (transformProperty === 'translate') {
          newTransform = transformFunction + ' ' + currentTransform;
        }

        else {
          newTransform = currentTransform + ' ' + transformFunction;
        }
      }

      else {
        var propertyEndIndex = currentTransform.slice(propertyIndex).indexOf(')');
        var currentTransformStart = currentTransform.slice(0, propertyIndex);
        var currentTransformEnd = currentTransform.slice(propertyIndex + propertyEndIndex + 1);

        newTransform = currentTransformStart + ' ' + transformFunction + currentTransformEnd;
      }
    }

    // console.log(newTransform);

    if (newTransform && newTransform !== currentTransform) {
      elem.style.transform = newTransform;
    }
  }

  function translate (elem, options) {
    var dx, dy;

    if (options.constrain === true) {
      var constrained = constrain(options);

      dx = constrained.dx;
      dy = constrained.dy;
    }

    else {
      dx = options.dx;
      dy = options.dy;
    }

    setTransform(elem, 'translate', dx + 'px,' + dy + 'px');

    return { dx: dx, dy: dy };
  }

  function constrain (options) {
    var dx = options.dx;
    var dy = options.dy;
    var width = options.width;
    var height = options.height;
    var viewportWidth = options.viewportWidth || width;
    var viewportHeight = options.viewportHeight || height;
    var scale = options.scale || 1;

    var newDx;
    var newDy;

    var allowedOffsetLeft = -((scale * width) - viewportWidth);
    var allowedOffsetRight = 0;

    if (allowedOffsetRight < allowedOffsetLeft) {
      allowedOffsetRight = allowedOffsetLeft;
      allowedOffsetLeft = 0;
    }

    var allowedOffsetTop = 0;
    var allowedOffsetBottom = -((scale * height) - viewportHeight);

    if (allowedOffsetBottom < allowedOffsetTop) {
      allowedOffsetTop = allowedOffsetBottom;
      allowedOffsetBottom = 0;
    }

    if (dx < allowedOffsetLeft) {
      newDx = (allowedOffsetLeft - dx) / 2 + dx;

      if (newDx < allowedOffsetLeft) {
        newDx = allowedOffsetLeft;
      }
    }

    else if (dx > allowedOffsetRight) {
      newDx = dx - (dx - allowedOffsetRight) / 2 + dx;

      if (newDx > allowedOffsetRight) {
        newDx = allowedOffsetRight;
      }
    }

    if (dy < allowedOffsetTop) {
      newDy = (allowedOffsetTop - dy) / 2 + dy;

      if (newDy < allowedOffsetTop) {
        newDy = allowedOffsetTop;
      }
    }

    else if (dy > allowedOffsetBottom) {
      newDy = dy - (dy - allowedOffsetBottom) / 2 + dy;

      if (newDy > allowedOffsetBottom) {
        newDy = allowedOffsetBottom;
      }
    }

    return { dx: newDx, dy: newDy };
  }

  function animateWhile (fn) {
    return new Promise (function (resolve) {
      requestAnimationFrame(function loop () {
        if (fn() === true) {
          requestAnimationFrame(loop);
        }

        else {
          resolve();
        }
      });
    });
  }


  /////

  function PanZoom (selectorOrElement, options) {
    this.elem = getElement(selectorOrElement);

    if (!this.elem) {
      throw new Error('panzoom: No such element ' + selectorOrElement);
    }

    options || (options = {});

    this.autosize = options.autosize || false;
    this.ctrlKeyToPan = options.ctrlKeyToPan || false;
    this.paddingLeft = options.paddingLeft || 0;
    this.paddingRight = options.paddingRight || 0;
    this.paddingTop = options.paddingTop || 0;
    this.paddingBottom = options.paddingBottom || 0;
    this.zoomMinDefault = options.zoomMin || 0.25;
    this.zoomMin = this.zoomMinDefault;
    this.zoomMax = options.zoomMax || 1.5;
    this.zoomIncrement = options.zoomIncrement || 0.1;
    this.zoomSpeed = options.zoomSpeed || 250;
    this.zoomType = options.zoomType || 'pixel'; // pixel or spin in wheel data
    // this.zoomControl = getElement(options.zoomControl);
    // this.zoomInButton = getElement(options.zoomInButton);
    // this.zoomOutButton = getElement(options.zoomOutButton);
    this.zoomDelegate = getElement(options.zoomDelegate) || this.elem.parentNode;
    this.panDelegate = getElement(options.panDelegate) || this.elem.parentNode;
    this.panTransitionIncrement = options.panTransitionIncrement || 0.1;
    this.zoomTransitionIncrement = options.zoomTransitionIncrement || 0.05;
    this.panGutterLeft = options.panGutterLeft || null;
    this.panGutterRight = options.panGutterRight || null;

    this.currentScale = 1;
    this.viewportFocusXRatio = 0.5;
    this.viewportFocusYRatio = 0.5;
    this.imageOriginX = 0;
    this.imageOriginY = 0;
    this.dx = 0;
    this.dy = 0;
    this.offsetX = 0;
    this.offsetY = 0;
    this.panStartX = null;
    this.panStartY = null;
    this.panStartPageX = null;
    this.panStartPageY = null;
    this.pinchZoom = null;
    this.pinchDirection = [];
    this.waitingForAnimation = false;
    this.omitSmallShapes = options.omitSmallShapes || false;
    this.constrain = options.constrain || false;
    
    const imageSize = dimensions(this.elem);
    this.width = imageSize.width;
    this.height = imageSize.height;
    this.aspectRatio = this.width / this.height;
    this.viewBox = this.getViewBox();

    // this.left = imageSize.x + (this.viewBox[0] || 0);
    // this.top = imageSize.y + (this.viewBox[1] || 0);
    // this.captureDimensions();

    this.pan = this.pan.bind(this);
    this.panStart = this.panStart.bind(this);
    this.panStop = this.panStop.bind(this);
    this.panWaitForReenter = this.panWaitForReenter.bind(this);
    this.panResume = this.panResume.bind(this);
    this.resize = this.resize.bind(this);
    this._getScale = this._getScale.bind(this);
    this._getOffset = this._getOffset.bind(this);
    this._getZoomRange = this._getZoomRange.bind(this);

    this.on = {
      scale: [],
      offset: [],
      resize: [],
      click: []
    };
    
    this.initializeStyles();
    this.initializePan();
    this.initializeZoom();

    // var aspectRatio = this.width / this.height;

    // console.log('init', this.viewportWidth, this.viewportHeight, this.width, this.height, aspectRatio);
    
    this.setViewportOriginRatio(0.5, 0.5);
  }

  PanZoom.prototype = {
    constructor: PanZoom,

    getViewBox: function () {
      if (!(this.elem instanceof SVGElement)) {
        return [];
      }

      var attr = this.elem.getAttribute('viewBox');

      if (!attr) {
        return [];
      }

      return attr.split(/\s+|\s*,/).map(Number);
    },

    captureDimensions: function () {
      // var imageSize = dimensions(this.elem);
      var parentSize = dimensions(this.elem.parentNode);

      this.viewportWidth = parentSize.width;
      this.viewportHeight = parentSize.height;

      const { paddingLeft, paddingRight, paddingTop, paddingBottom } = this.getPadding();

      this.defaultScale = Math.min(
        this.viewportWidth / (this.width + paddingLeft + paddingRight),
        this.viewportHeight / (this.height + paddingTop + paddingBottom)
      );
      
      // Apply zoomMin in constructor options, if they are greater
      this.zoomMin = Math.max(this.defaultScale, this.zoomMinDefault);

      // console.log('captureDimensions', { defaultScale: this.defaultScale, zoomMin: this.zoomMin, zoomMinDefault: this.zoomMinDefault, viewportWidth: this.viewportWidth, viewportHeight: this.viewportHeight, imageWidth: this.width, imageHeight: this.height, paddingLeft, paddingRight, paddingTop, paddingBottom });


      // console.log('dim', { elem: [this.width, this.height], aspect: this.aspectRatio, defaultScale: this.defaultScale, parent: [this.viewportWidth, this.viewportHeight], box: [this.boxWidth, this.boxHeight]});
    },

    initializeStyles: function () {
      var style = this.elem.style;
      var parentStyle = this.elem.parentNode.style;

      // for zoom
      // style.transformOrigin = '50% 50%';
      style.transformOrigin = '0 0';
      // style.transition = 'transform-origin 0.38s ease-in';
      parentStyle.overflow = 'hidden';

      if (this.zoomInButton) {
        this.zoomInButton.style.cursor = 'zoom-in';
      }

      if (this.zoomOutButton) {
        this.zoomOutButton.style.cursor = 'zoom-out';
      }

      // for pan
      style.cursor = 'drag';
    },

    scale: function (newScale) {
      // console.log('scale', { newScale, currentScale: this.currentScale, zoomMin: this.zoomMin, zoomMax: this.zoomMax })

      if (newScale < this.zoomMin) {
        newScale = this.zoomMin;
      }

      else if (newScale > this.zoomMax) {
        newScale = this.zoomMax;
      }

      if (newScale === this.currentScale) {
        return;
      }

      this.currentScale = newScale;
      this.updateTransform();


      if (this.constrain) {
        this.panRefresh();
      }

      if (this.updateZoomControl) {
        this.updateZoomControl();
      }
    },

    scaleSquare (scale) {
      const { zoomMin, zoomMax } = this;
      const range = zoomMax - zoomMin;
      const valueRatio = (scale - zoomMin) / range;
      const adjustedRatio = valueRatio * valueRatio;
      const adjustedScale = adjustedRatio * range + zoomMin;

      return adjustedScale;
    },

    scaleSquareRoot (adjustedScale) {
      const { zoomMin, zoomMax } = this;
      const range = zoomMax - zoomMin;
      const adjustedRatio = (adjustedScale - zoomMin) / range;
      const valueRatio = Math.sqrt(adjustedRatio);
      const scale = valueRatio * range + zoomMin;
      
      return scale;
    },

    zoomIn: function (deltaScale = 1) {
      const adjustedScale = this.scaleSquareRoot(this.currentScale);
      let newScale = this.scaleSquare(adjustedScale + deltaScale);

      // Prevent juddering scale at end of range by snapping to min/max
      // on large deltaScales
      const SNAP = 0.2;

      if (deltaScale > 0.1 && this.zoomMax - newScale < SNAP) {
        newScale = this.zoomMax;
      }

      else if (deltaScale < -0.1 && newScale - this.zoomMin < SNAP) {
        newScale = this.zoomMin;
      }

      return this.scale(newScale);
    },

    zoomOut: function (deltaScale = 1) {
      return this.zoomIn(-deltaScale);
    },

    translate: function (dx, dy) {
      if (dx === this.dx && dy === this.dy) {
        return;
      }

      // TODO constrain
      this.dx = dx;
      this.dy = dy;

      return this.updateTransform();

      // return { dx: dx, dy: dy };


      // return translate(this.elem, {
      //   dx: dx,
      //   dy: dy,
      //   width: this.width,
      //   height: this.height,
      //   viewportWidth: this.viewportWidth,
      //   viewportHeight: this.viewportHeight,
      //   scale: this.currentScale,
      //   constrain: this.constrain
      // });
    },

    setViewportOriginRatio: function (xRatio, yRatio) {
      // if (debug) {
      //   console.log('setViewportOriginRatio', { xRatio, yRatio, viewportWidth: this.viewportWidth, viewportHeight: this.viewportHeight }, xRatio * this.viewportWidth, yRatio * this.viewportHeight);
      // }

      return this.setViewportOrigin(xRatio * this.viewportWidth, yRatio * this.viewportHeight);
    },

    setViewportOrigin: function (viewportX, viewportY) {
      var xRatio = (viewportX - this.dx) / this.viewportWidth;
      var yRatio = (viewportY - this.dy) / this.viewportHeight;

      if (xRatio === this.viewportFocusXRatio && yRatio === this.viewportFocusXRatio) {
        return;
      }

      // Ratio of client position in parent's box
      this.viewportFocusXRatio = xRatio;
      this.viewportFocusYRatio = yRatio;

      return this.updateTransform();
    },

    setOriginViaViewportRatio: function (xRatio, yRatio, updateViewportOrigin) {
      return this.setOriginViaViewport(this.viewportWidth * xRatio, this.viewportHeight * yRatio, updateViewportOrigin);
    },

    setOriginViaViewport: function (viewportX, viewportY, updateViewportOrigin) {
      var imageOriginX = (viewportX / this.currentScale) - this.offsetX + this.viewBox[0];
      var imageOriginY = (viewportY / this.currentScale) - this.offsetY + this.viewBox[1];

      // imageOriginX = this.width / 2 + this.viewBox[0];
      // imageOriginY = this.height / 2 + this.viewBox[1];

      if (updateViewportOrigin) {
        this.setViewportOrigin(viewportX, viewportY);
      }

      // console.log('setOriginViaViewport', {viewportX, viewportY, imageOriginX, imageOriginY, viewBox: this.viewBox, viewportWidth: this.viewportWidth, viewportHeight: this.viewportHeight, offsetX: this.offsetX, offsetY: this.offsetY});

      return this.setImageOrigin(imageOriginX, imageOriginY);
    },

    setImageOrigin: function (x, y) {
      if (typeof x === 'number' && !isNaN(x) && typeof y === 'number' && !isNaN(y)) {
        // const imageOriginX = x + this.viewBox[0];
        // const imageOriginY = y + this.viewBox[1];

        // if (imageOriginX === this.imageOriginX && imageOriginY === this.imageOriginY) {
        //   return;
        // }

        if (x === this.imageOriginX && y === this.imageOriginY) {
          return;
        }

        this.imageOriginX = x;
        this.imageOriginY = y;

        this.updateTransform();
      }
    },

    updateTransform: function (isResize) {
      if (isResize) {
        this.captureDimensions();
      }

      this.offsetX = (this.viewportWidth * this.viewportFocusXRatio + this.dx) / this.currentScale - (this.imageOriginX - this.viewBox[0]);

      this.offsetY = (this.viewportHeight * this.viewportFocusYRatio + this.dy) / this.currentScale - (this.imageOriginY - this.viewBox[1]);

      // this.offsetX = Math.round((this.viewportWidth * this.viewportFocusXRatio + this.dx) / this.currentScale - this.imageOriginX);

      // this.offsetY = Math.round((this.viewportHeight * this.viewportFocusYRatio + this.dy) / this.currentScale - this.imageOriginY);

      if (this.waitingForAnimation) {
        return;
      }

      this.waitingForAnimation = true;

      // console.log('updateTransform', {
      //   dx: this.dx,
      //   dy: this.dy,
      //   viewportWidth: this.viewportWidth,
      //   viewportHeight: this.viewportHeight,
      //   viewportFocusXRatio: this.viewportFocusXRatio,
      //   viewportFocusYRatio: this.viewportFocusYRatio,
      //   imageOriginX: this.imageOriginX,
      //   imageOriginY: this.imageOriginY,
      //   currentScale: this.currentScale,
      //   offsetX: this.offsetX,
      //   offsetY: this.offsetY,
      //   isResize
      // });

      requestAnimationFrame(() => {
        var transform = '';

        // if (this.left || this.top) {
        //   transform += 'translate(' + -this.left + 'px,' + -this.top + 'px)';
        // }

        if (this.currentScale) {
          // transform += 'scale(' + this.currentScale.toFixed(5) + ') ';
          const scale = this.currentScale;
          const originX = this.viewBox[0] - this.currentScale * this.viewBox[0];
          const originY = this.viewBox[1] - this.currentScale * this.viewBox[1];

          transform += `matrix(${scale}, 0, 0, ${scale}, ${originX}, ${originY})`;
          
        }

        if (this.offsetX || this.offsetY) {
          // transform += 'translate(' + this.offsetX + 'px,' + this.offsetY + 'px)';
          transform += 'translate(' + this.offsetX + ',' + this.offsetY + ')';
        }

        this.elem.firstElementChild.setAttribute('transform', transform);


        // const minX = (- this.offsetX)  * this.currentScale;
        // const minY = (- this.offsetY)  * this.currentScale;
        // const width = this.viewportWidth / this.currentScale;
        // const height = this.viewportHeight / this.currentScale;

        // this.elem.setAttribute('viewBox', [minX, minY, width, height].join(' '));

        this.waitingForAnimation = false;

        const hasScaleListeners = this.on.scale.length;
        const hasOffsetListeners = this.on.offset.length;

        const notifyScaleChange = !!this.on.scale.length && this.previousScale !== this.currentScale;
        const notifyOffsetChange = !!this.on.offset.length && (this.previousOffsetX !== this.offsetX || this.previousOffsetY !== this.offsetY);
        
        if (this.on.scale.length) {
          if (this.previousScale !== this.currentScale) {
            this.on.scale.forEach(this._getScale);
          }

          this.previousScale = this.currentScale;
        }

        if (this.on.offset.length) {
          if (this.previousOffsetX !== this.offsetX || this.previousOffsetY !== this.offsetY) {
            this.on.offset.forEach(this._getOffset);
          }

          this.previousOffsetX = this.offsetX;
          this.previousOffsetY = this.offsetY;
        }

        // const notifyResize = this.on.resize.length > 0 && isResize;

        if (this.on.resize.length) {
          if (isResize) {
            this.on.resize.forEach(this._getZoomRange);
          }
        }
      });
    },

    _getScale: function (fn) {
      fn(this.currentScale);
    },

    _getOffset: function (fn) {
      fn({
        dx: this.dx,
        dy: this.dy,
        offsetX: this.offsetX,
        offsetY: this.offsetY
      });
    },

    _getZoomRange: function (fn) {
      fn({
        zoomMin: this.zoomMin,
        zoomMax: this.zoomMax
      });
    },

    onScaleChange: function (fn) {
      this.on.scale.push(fn);
    },

    onOffsetChange: function (fn) {
      this.on.offset.push(fn);
    },

    onResize: function (fn) {
      this.on.resize.push(fn);
    },

    onClick: function (fn) {
      this.on.click.push(fn);
    },

    // fitToContainer: function () {
    //   if (this.defaultScale < 1) {
    //     this.scale(this.defaultScale);
    //     this.setOriginViaViewportRatio(0.5, 0.5, true);
    //   }
    // },

    center: function (bboxOrElem) {
      const bbox = bboxOrElem instanceof SVGElement ?
        bboxOrElem.getBBox() : bboxOrElem;

      return this.setImageOrigin(bbox.x + bbox.width / 2, bbox.y + bbox.height / 2);
    },

    contain: function (bboxOrElem, { scaleRatio = 1, animate = false, inSeries = false } = {}) {
      const bbox = bboxOrElem instanceof SVGElement ?
        bboxOrElem.getBBox() : bboxOrElem;

      // TODO transition dx,dy => transfer to imageOriginX/Y
      // TODO use viewBox

      const xTo = bbox.x + bbox.width / 2;
      const yTo = bbox.y + bbox.height / 2;
      const scaleTo = Math.min(this.zoomMax, scaleRatio * this.viewportWidth / bbox.width, scaleRatio * this.viewportHeight / bbox.height);

      // console.log('contain', {animate, xTo, yTo, scaleRatio, scaleTo, zoomMax: this.zoomMax, bbox});

      if (!animate) {
        this.setImageOrigin(xTo, yTo);
        this.scale(scaleTo);
        // console.log(2,dimensions(this.elem.parentNode));
        return Promise.resolve();
      }

      let promise = Promise.resolve();

      if (xTo !== this.imageOriginX && yTo !== this.imageOriginY) {
        const deltaX = Math.abs(xTo - this.imageOriginX) * this.panTransitionIncrement;
        const deltaY = Math.abs(yTo - this.imageOriginY) * this.panTransitionIncrement;

        const animatePan = () => {
          return animateWhile(() => {
            let newX, newY;

            if (this.imageOriginX < xTo) {
              newX = this.imageOriginX + deltaX;

              if (newX > xTo) {
                newX = xTo;
              }
            }

            else {
              newX = this.imageOriginX - deltaX;

              if (newX < xTo) {
                newX = xTo;
              }
            }

            if (this.imageOriginY < yTo) {
              newY = this.imageOriginY + deltaY;

              if (newY > yTo) {
                newY = yTo;
              }
            }

            else {
              newY = this.imageOriginY - deltaY;

              if (newY < yTo) {
                newY = yTo;
              }
            }

            this.setImageOrigin(newX, newY);

            return newX !== xTo || newY !== yTo;
          });
        };

        promise = promise.then(animatePan());
      }

      if (scaleTo !== this.currentScale) {
        const deltaScale = Math.abs(scaleTo - this.currentScale) * this.zoomTransitionIncrement;

        const animateZoom = () => {
          return animateWhile(() => {
            let newScale;

            if (this.currentScale < scaleTo) {
              newScale = this.currentScale + deltaScale;

              if (newScale > scaleTo) {
                newScale = scaleTo;
              }
            }

            else {
              newScale = this.currentScale - deltaScale;

              if (newScale < scaleTo) {
                newScale = scaleTo;
              }
            }

            this.scale(newScale);

            return newScale !== scaleTo;
          });
        }

        if (inSeries) {
          promise = promise.then(animateZoom());
        }

        else {
          promise = Promise.all([promise, animateZoom()]);
        }
      }

      return promise;
      // return promise.then(() => console.log(3,dimensions(this.elem.parentNode)));
    },

    getPadding: function () {
      let { paddingLeft, paddingRight, paddingTop, paddingBottom } = this;

      if (typeof paddingLeft === 'string' && paddingLeft.slice(-1) === '%') {
        paddingLeft = Math.round(parseInt(paddingLeft) * this.width / 100);
      }

      if (typeof paddingRight === 'string' && paddingRight.slice(-1) === '%') {
        paddingRight = Math.round(parseInt(paddingRight) * this.width / 100);
      }

      if (typeof paddingTop === 'string' && paddingTop.slice(-1) === '%') {
        paddingTop = Math.round(parseInt(paddingTop) * this.height / 100);
      }

      if (typeof paddingBottom === 'string' && paddingBottom.slice(-1) === '%') {
        paddingBottom = Math.round(parseInt(paddingBottom) * this.height / 100);
      }

      return { paddingLeft, paddingRight, paddingTop, paddingBottom };
    },

    resetView: function (animate) {
      // TODO animate dx,dy
      if (this.dx || this.dy) {
        this.dx = 0;
        this.dy = 0;
      }

      this.captureDimensions();
      
      this.setOriginViaViewportRatio(0.5, 0.5, true);

      const { paddingLeft, paddingRight, paddingTop, paddingBottom } = this.getPadding();

      // console.log('padding', { paddingLeft, paddingRight, paddingTop, paddingBottom });

      return this.contain({
        x: -paddingLeft + this.viewBox[0],
        y: -paddingTop + this.viewBox[1], 
        width: this.width + paddingLeft + paddingRight,
        height: this.height + paddingTop + paddingBottom
      }, { animate });
    },

    resize: function () {
      this.updateTransform(true);
    },

    initializeZoomControl: function () {
      var zoomControl = this.zoomControl;

      if (!zoomControl) {
        throw new Error('panzoom: No such zoom control ' + selectorOrElement);
      }

      var optionElems = zoomControl.querySelectorAll('option');
      var zoomValues = Array.prototype.slice.apply(optionElems)
      .map(function (option) {
        return Number(option.value) / 100;
      });

      var instance = this;

      zoomControl.addEventListener('change', function (event) {
        instance.scale(zoomValues[zoomControl.selectedIndex]);
      });

      this.updateZoomControl = function () {
        var currentSelection = zoomControl.selectedIndex;
        var closestIndex = 0;

        for (var i = 1; i < zoomValues.length; i ++) {
          if (Math.abs(this.currentScale - zoomValues[i]) < Math.abs(this.currentScale - zoomValues[closestIndex])) {
            closestIndex = i;
          }
        }

        if (currentSelection !== closestIndex) {
          zoomControl.selectedIndex = closestIndex;
        }
      };
    },

    initializeZoomInOut: function () {
      var zoomInButton = this.zoomInButton;

      if (!zoomInButton) {
        throw new Error('panzoom: No such zoom in control');
      }

      var zoomOutButton = this.zoomOutButton;

      if (!zoomOutButton) {
        throw new Error('panzoom: No such zoom out control');
      }

      var instance = this;

      zoomInButton.addEventListener('click', function (event) {
        instance.scaleSquare(instance.currentScale + instance.zoomIncrement);
      });

      zoomOutButton.addEventListener('click', function (event) {
        instance.scaleSquare(instance.currentScale - instance.zoomIncrement);
      });
    },

    getWheelData: function (event) {
      // Modified from https://github.com/facebookarchive/fixed-data-table/blob/master/src/vendor_upstream/dom/normalizeWheel.js
      var PIXEL_STEP  = 10;
      var LINE_HEIGHT = 40;
      var PAGE_HEIGHT = 800;

      var sX = 0, sY = 0,       // spinX, spinY
          pX = 0, pY = 0;       // pixelX, pixelY

      // Legacy
      if ('detail'      in event) { sY = event.detail; }
      if ('wheelDelta'  in event) { sY = -event.wheelDelta / 120; }
      if ('wheelDeltaY' in event) { sY = -event.wheelDeltaY / 120; }
      if ('wheelDeltaX' in event) { sX = -event.wheelDeltaX / 120; }

      // side scrolling on FF with DOMMouseScroll
      if ( 'axis' in event && event.axis === event.HORIZONTAL_AXIS ) {
        sX = sY;
        sY = 0;
      }

      pX = sX * PIXEL_STEP;
      pY = sY * PIXEL_STEP;

      if ('deltaY' in event) { pY = event.deltaY; }
      if ('deltaX' in event) { pX = event.deltaX; }

      if ((pX || pY) && event.deltaMode) {
        if (event.deltaMode === 1) {          // delta in LINE units
          pX *= LINE_HEIGHT;
          pY *= LINE_HEIGHT;
        } else {                             // delta in PAGE units
          pX *= PAGE_HEIGHT;
          pY *= PAGE_HEIGHT;
        }
      }

      // Fall-back if spin cannot be determined
      if (pX && !sX) { sX = (pX < 1) ? -1 : 1; }
      if (pY && !sY) { sY = (pY < 1) ? -1 : 1; }

      return { spinX  : sX,
               spinY  : sY,
               pixelX : pX,
               pixelY : pY };
    },

    initializeScrollToZoom: function () {
      addWheelListener(this.zoomDelegate || this.elem, (event) => {
        event.preventDefault();

        var wheelData = this.getWheelData(event);
        var wheelAmount = this.zoomType === 'spin' ?
          (wheelData.spinX + wheelData.spinY) :
          (wheelData.pixelX + wheelData.pixelY);

        this.setOriginViaViewport(event.clientX - this.zoomDelegate.offsetLeft, event.clientY - this.zoomDelegate.offsetTop, true);
        // this.setOriginViaViewport(event.pageX - window.scrollX, event.pageX - window.scrollY, true);
        

        // this.scale(this.currentScale + wheelAmount / this.zoomSpeed);
        this.zoomIn(-wheelAmount / this.zoomSpeed);
      });
    },

    initializeZoom: function () {
      if (this.zoomControl) {
        this.initializeZoomControl();
      }

      if (this.zoomInButton && this.zoomOutButton) {
        this.initializeZoomInOut();
      }

      if (this.autosize) {
        this.resetView();

        window.addEventListener('resize', this.resize);
      }

      this.initializeScrollToZoom();
    },

    pointerPosition (event) {
      const x = event.touches && event.touches[0].pageX || event.pageX;
      const y = event.touches && event.touches[0].pageY || event.pageY;

      return { x, y };
    },

    // Re-translate to benefit from pan restrictions on zoom
    panRefresh: function () {
      return this.translate(this.dx, this.dy);

      // this.dx = translation.dx;
      // this.dy = translation.dy;
    },

    addPanListeners: function () {
      // var options = passiveEventsSupported ? { passive: false } : undefined;

      // this.panDelegate.addEventListener('pointermove', this.pan);
      this.panDelegate.addEventListener('mousemove', this.pan);
      this.panDelegate.addEventListener('touchmove', this.pan);
      // this.panDelegate.addEventListener('pointerup', this.panStop);
      this.panDelegate.addEventListener('mouseup', this.panStop);
      this.panDelegate.addEventListener('touchend', this.panStop);
      this.panDelegate.addEventListener('mouseleave', this.panWaitForReenter);
    },

    removePanListeners: function () {
      // this.panDelegate.removeEventListener('pointermove', this.pan);
      this.panDelegate.removeEventListener('mousemove', this.pan);
      this.panDelegate.removeEventListener('touchmove', this.pan);
      // this.panDelegate.removeEventListener('pointerup', this.panStop);
      this.panDelegate.removeEventListener('mouseup', this.panStop);
      this.panDelegate.removeEventListener('touchend', this.panStop);
      this.panDelegate.removeEventListener('mouseleave', this.panWaitForReenter);
      this.panDelegate.removeEventListener('mouseenter', this.panResume);
    },

    panStart: function (event) {
      // console.log('panStart', Date.now(), event.type, !!event.touches);

      if (this.panStartX !== null || (this.ctrlKeyToPan && !event.ctrlKey && !event.metaKey)) {
        return;
      }

      const { x, y } = this.pointerPosition(event);

      // Don't start panning, if started within pan gutter
      if (
        (this.panGutterLeft && x < this.panGutterLeft) ||
        (this.panGutterRight && x > this.viewportWidth - this.panGutterRight)
      ) {
        return;
      }

      // console.log('* panStart *', event, event.target !== this.elem && event.target.nodeName !== 'svg' && event.target instanceof SVGElement);

      // Prevent pan trigger on small content
      if (this.omitSmallShapes && event.target !== this.elem && event.target.nodeName !== 'svg') {
        if (event.target instanceof SVGElement) {
          var size = dimensions(event.target);
          var diff = Math.min(Math.abs(this.width - size.width), Math.abs(this.height - size.height));

          if (diff > 50) {
            return;
          }
        }
      }

      event.preventDefault();
      event.stopPropagation();
      event.stopImmediatePropagation();


      // pan
      this.panning = true;
      this.panStartTime = Date.now();
      this.panStopTime = null;
      this.panStartPageX = x;
      this.panStartPageY = y;

      this.panStartX = x - this.dx;
      this.panStartY = y - this.dy;
      this.elem.style.cursor = 'grabbing';

      // console.log('*** panStart ***', { x, dx: this.dx, panStartX: this.panStartX });

      // pinch & zoom
      const touches = event.touches;

      if (touches && touches.length === 2) {
        // console.log('touches', event);
        // this.scaling = true;

        // console.log('panStart', !!Math.hypot, touches);

        this.pinchZoom = Math.hypot(
          touches[0].pageX - touches[1].pageX,
          touches[0].pageY - touches[1].pageY
        );
      }

      this.addPanListeners();
    },

    panStop: function (event) {
      // if (event) {
      //   event.preventDefault();
      // }

      // console.log('panStop', Date.now());
      this.panStopTime = Date.now();

      const panChanged = event && (
        Math.abs(this.panStartPageX - event.pageX) > 10 ||
        Math.abs(this.panStartPageY - event.pageY) > 10
      );

      // pan change; prevent mouseOver/click
      if (panChanged) {
        event.preventDefault();  
      }

      this.panning = false;
      this.panStartX = this.panStartY = this.pinchZoom = null;
      this.pinchDirection = [];
      this.scaling = false;
      this.elem.style.cursor = 'grab';

      this.removePanListeners();

      if (!panChanged && this.on.click.length) {
        this.on.click.forEach(fn => fn(event));
      }
    },

    pan: function (event) {
      const PINCHZOOM_FACTOR = 62;

      event.preventDefault();

      const touches = event.touches;

      // console.log('pan');

      if (touches && touches.length === 2) {
        const x1 = touches[0].pageX;
        const y1 = touches[0].pageY;
        const x2 = touches[1].pageX;
        const y2 = touches[1].pageY;
        const diffX = x2 - x1;
        const diffY = y2 - y1;
        const centerX = Math.abs(x1 + diffX / 2);
        const centerY = Math.abs(y1 + diffY / 2);
        const distance = Math.hypot(diffX, diffY);

        const previousPinchZoom = this.pinchZoom;

        this.pinchZoom = distance;

        // console.log({previousPinchZoom});

        if (previousPinchZoom !== null) {
          const distanceDiff = distance - previousPinchZoom;
          let deltaScale = distanceDiff / PINCHZOOM_FACTOR;

          if (Math.abs(deltaScale) < 0.002) {
            // console.log({deltaScale});

            this.pinchZoom = previousPinchZoom;
            return;
          }

          // Counter glitchy Android pinch/zoom measurement with averages
          const isZoomingIn = distanceDiff > 0;
          const isDirectionChange = this.pinchDirection.length > 3 && this.pinchDirection[this.pinchDirection.length - 1] !== isZoomingIn;

          if (isDirectionChange) {
            const agreement = this.pinchDirection.reduce((result, measurement) => result + (measurement === isZoomingIn ? 1 : 0), 0);

            // console.log('fix?', { deltaScale, isZoomingIn, isDirectionChange, agreement, len: this.pinchDirection.length});

            if (agreement < this.pinchDirection.length / 2) {
              // console.log('fix', deltaScale);
              deltaScale = -deltaScale;
            }
          }

          this.pinchDirection.push(isZoomingIn);

          if (this.pinchDirection.length > 5) {
            this.pinchDirection.shift();
          }

          // console.log('pan', {previousPinchZoom, distance, deltaScale, isZoomingIn, isDirectionChange}, centerX - this.zoomDelegate.offsetLeft, centerY - this.zoomDelegate.offsetTop);

          // console.log('pan, pinch', touches[0], {diffX, diffY, centerX, centerY});

          this.setOriginViaViewport(centerX - this.zoomDelegate.offsetLeft, centerY - this.zoomDelegate.offsetTop, true);

          this.zoomIn(deltaScale);
        }
      }

      else {
        const { x, y } = this.pointerPosition(event);

        this.translate(
          x - this.panStartX,
          y - this.panStartY
        );
      }

      // dx, dy may be constrained
      // this.dx = translation.dx;
      // this.dy = translation.dy;
    },

    panResume: function (event) {
      event.preventDefault();

      if (event.buttons !== 1) {
        this.panStop();
      }

      else {
        const { x, y } = this.pointerPosition(event);

        this.panStartX = x - this.dx;
        this.panStartY = y - this.dy;
      }

      document.removeEventListener('mouseenter', this.panResume);
    },

    panWaitForReenter: function (event) {
      event.preventDefault();
      document.addEventListener('mouseenter', this.panResume);
    },

    initializePan: function () {
      this.panStartX = this.panStartY = null;

      var elem = this.panDelegate || this.elem;

      // var options = passiveEventsSupported ? { passive: false } : undefined;

      // elem.addEventListener('pointerdown', this.panStart);
      elem.addEventListener('mousedown', this.panStart);
      elem.addEventListener('touchstart', this.panStart);
    }
  };

  return function panzoom (selectorOrElement, options) {
    return new PanZoom(selectorOrElement, options);
  };

}(...(typeof window === 'undefined' ? [] : [window, document])));



// WEBPACK FOOTER //
// ./lib/panzoom.js